/**
 * API 설정 파일
 * 환경에 따라 API URL을 자동으로 설정합니다.
 */

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://" + window.location.hostname + "/api";
const CHAT_URL = process.env.REACT_APP_CHAT_URL || "http://" + window.location.hostname + "/ws";

export const CHAT = {
  MSG_URL: `${CHAT_URL}`,
  CHAT_URL: `${CHAT_URL}/chat`
};

export const API = {
  BASE_URL: `${BASE_URL}`,

  // User 관련
  LOGIN: `${BASE_URL}/auth/login`,
  USER_LIST: `${BASE_URL}/user`,
  USER_DEALER_LIST: `${BASE_URL}/user/dealer`,
  USER_INFO: `${BASE_URL}/user`,
  USER_ATTENDANCE_INSERT: `${BASE_URL}/user/attendance`,
  USER_ATTENDANCE_DATE: `${BASE_URL}/user/attendance`,
  USER_ATTENDANCE_LIST: `${BASE_URL}/user/attendance/list`,
  USER_MEMO: `${BASE_URL}/user/memo/`,

  // Product 관련
  PRODUCT_LIST: `${BASE_URL}/product/page`,
  PRODUCT_INFO: `${BASE_URL}/product`,
  PRODUCT_REGIST: `${BASE_URL}/product/regist`,
  PRODUCT_INVENTORY: `${BASE_URL}/product/inventory`,

  // Sales 관련
  SALES_LIST: `${BASE_URL}/sales/`,
  SALES_DAY: `${BASE_URL}/sales/`,
  SALES_INSERT: `${BASE_URL}/sales`,
  SALES_CODE: `${BASE_URL}/sales/code`,
  SALES_USER: `${BASE_URL}/sales/user`,
  SALES_USER_TOTAL: `${BASE_URL}/sales/user/total`,
  SALES_TODAY: `${BASE_URL}/sales/today`,

  // Statistics 관련
  STATISTICS_MANUFACTURE_PRODUCT: `${BASE_URL}/statistics/manufacture/product`,
  STATISTICS_DAILY: `${BASE_URL}/statistics/daily`,
  STATISTICS_MONTHLY: `${BASE_URL}/statistics/monthly`,
  STATISTICS_HOURLY: `${BASE_URL}/statistics/hourly`,

  // Code 관련
  CODE_COMMON: `${BASE_URL}/common/code/`,
  CODE_CATEGORY: `${BASE_URL}/code/category`,
  CODE_GRADE: `${BASE_URL}/code/grade`,

  // Legacy (호환성 유지)
  RECRUITMENT: `${BASE_URL}`,
  FAQ: `${BASE_URL}/faq`,
  CREWRECRUIT: `${BASE_URL}/recruit`,
  MAIN: `${BASE_URL}`,
  MYPAGE: `${BASE_URL}/mypage`,
};